import { render, staticRenderFns } from "./ApplySchool.vue?vue&type=template&id=b61f03b8&"
import script from "./ApplySchool.vue?vue&type=script&lang=js&"
export * from "./ApplySchool.vue?vue&type=script&lang=js&"
import style0 from "./ApplySchool.vue?vue&type=style&index=0&id=b61f03b8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports